module.exports = __webpack_public_path__ + "img/img12.c2d5e323.png";